import Plugin, { init } from "@/modules/_utils/Plugin";
import LazyLoad from "vanilla-lazyload";

class Lazy extends Plugin {
  init() {
    const lazyLoad = new LazyLoad({
      elements_selector: ".lazy"
    });
  }
}

export default init(Lazy, "lazyload");
